import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import _map from 'lodash/map';
import _pickBy from 'lodash/pickBy';
import _compact from 'lodash/compact';
import _isEmpty from 'lodash/isEmpty';

import { Row, Col } from 'react-flexbox-grid';

import { contextType } from 'types';
import InspectHeader from 'components/InspectHeader';
import InspectButton from 'components/InspectButton';

import FormGroupAutoCompleteField from 'components/AutoCompleteMenuWrapper';

import './style.scss';

export default class Context extends Component {
  static propTypes = {
    isArchived: PropTypes.bool.isRequired,
    onCreateContext: PropTypes.func.isRequired,
    onSearchContext: PropTypes.func.isRequired,
    allContexts: PropTypes.arrayOf(contextType),
    context: contextType,
    isLoading: PropTypes.bool,
  };

  renderOverView = ({ name, blocks }) => {
    const pairs = _compact(
      _map(blocks, ({ id, name, values }) => {
        const setValues = _pickBy(values, value => value !== '');

        if (!_isEmpty(setValues)) {
          return (
            <table key={id} className="block">
              <thead>
                <tr>
                  <th colSpan={2}>{name}</th>
                </tr>
              </thead>

              <tbody>{_map(setValues, this.renderBlockProperty)}</tbody>
            </table>
          );
        }

        return null;
      }),
    );

    return (
      <div className="quick-view">
        <div className="name">{name}</div>

        {pairs.length > 0 ? (
          pairs
        ) : (
          <div className="empty">No values to show</div>
        )}
      </div>
    );
  };

  renderBlockProperty = (value, key) => (
    <tr key={key}>
      <td>{key}</td>
      <td disabled>{value}</td>
    </tr>
  );

  renderBlock = (block, index) => (
    <Col key={index} data-test="block-table" md={6} xs={12}>
      <table className="context-attributes --table" data-test="block-table">
        <thead>
          <tr>
            <th colSpan="2">{block.name}</th>
          </tr>
        </thead>

        <tbody>{_map(block.values, this.renderBlockProperty)}</tbody>
      </table>
    </Col>
  );

  render() {
    const {
      isArchived,
      isLoading,
      context,
      allContexts,
      onCreateContext,
      onSearchContext,
    } = this.props;

    return (
      <div styleName="root">
        <InspectHeader>
          {!isArchived && (
            <InspectButton
              isHeader
              data-test="create-context"
              onClick={onCreateContext}
            >
              + Create New Context
            </InspectButton>
          )}
        </InspectHeader>

        <div styleName="inner">
          <Row>
            <Col xs={12}>
              <Row>
                <Col xs={6}>
                  <Field
                    withDropCross
                    component={FormGroupAutoCompleteField}
                    data-test="context-selection"
                    isArchived={context?.archived}
                    isDisabled={isArchived}
                    isLoading={isLoading}
                    items={allContexts}
                    label="CONTEXT NAME"
                    name="context"
                    placeholder="Select a context"
                    renderOverView={this.renderOverView}
                    onChangeValue={onSearchContext}
                    onOpen={onSearchContext}
                  />
                </Col>
              </Row>

              {context && (
                <Row data-test="blocks">
                  {_map(context.blocks, this.renderBlock)}
                </Row>
              )}
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}
